import React from "react";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import "../styles/AP.scss";

function ReadyBuildsAdmin() {
  return (
    <div className="readybuilds-admin">
      <h2>Редактор готовых сборок</h2>

      {/* Форма добавления/редактирования */}
      <form className="admin-form">
        <label>
          Название:
          <input type="text" placeholder="Введите название сборки" />
        </label>

        <label>
          Характеристики:
          <textarea placeholder="CPU, GPU, RAM и т.д." />
        </label>

        <label>
          Цена:
          <input type="text" placeholder="Например: 50 000 ₽" />
        </label>

        <label>
          Картинка (URL):
          <input type="text" placeholder="https://example.com/image.jpg" />
        </label>

        <button type="submit" className="btn">Сохранить</button>
      </form>

      {/* Таблица существующих сборок */}
      <div className="admin-list">
        <h3>Существующие сборки</h3>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Цена</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Игровая сборка</td>
              <td>55 000 ₽</td>
              <td>
                <button>✏️ Редактировать</button>
                <button>🗑️ Удалить</button>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>Офисная сборка</td>
              <td>25 000 ₽</td>
              <td>
                <button>✏️ Редактировать</button>
                <button>🗑️ Удалить</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Placeholder({ title }) {
  return (
    <div>
      <h2>{title}</h2>
      <p>Раздел в разработке...</p>
    </div>
  );
}

export default function AP() {
  return (
    <div className="admin-panel">
      <header className="admin-header">
        <h1>Админ-панель</h1>
      </header>

      <div className="admin-body">
        <aside className="admin-sidebar">
          <ul>
            <li><Link to="/admin/products">Готовые сборки</Link></li>
            <li><Link to="/admin/categories">Ноутбуки</Link></li>
            <li><Link to="/admin/users">Комплектующие</Link></li>
            <li><Link to="/admin/orders">Мониторы</Link></li>
            <li><Link to="/admin/settings">Прочее</Link></li>
          </ul>
        </aside>

        <main className="admin-content">
          <Routes>
            {/* редирект по умолчанию */}
            <Route path="/" element={<Navigate to="products" replace />} />

            <Route path="products" element={<ReadyBuildsAdmin />} />
            <Route path="categories" element={<Placeholder title="Ноутбуки" />} />
            <Route path="users" element={<Placeholder title="Комплектующие" />} />
            <Route path="orders" element={<Placeholder title="Мониторы" />} />
            <Route path="settings" element={<Placeholder title="Прочее" />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
